import { render } from "./BuildBenefit.vue?vue&type=template&id=6cc16168&ts=true"
import script from "./BuildBenefit.vue?vue&type=script&lang=ts"
export * from "./BuildBenefit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__